import { useEffect, useRef } from "react";
import "./loginandlandingpage.css";
import "./admininfo.css";
import "./admininfo2.css";
import "./styles.css";

import "./Components/Taxes/AssesmentDetails/DrillDownReport.css";//added for all components reload issue
import RoutesComponent from "./routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import { IdleTimerProvider } from "react-idle-timer";
import { config } from "./CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "./CommonUtils/CommonAxios";

function App() {

  const isLoggingOut = useRef(false);

  const handleOnIdle = () => {
    if (!isLoggingOut.current) {
      isLoggingOut.current = true;
      saveLoginTracker();
    }
  };




  const saveLoginTracker = async () => {
    const token = localStorage.getItem("token"); const refreshToken = JSON.parse(localStorage.getItem("refresh_token"));
    try {
      if (token) { await CommonAxiosGet("v1/logout"); }

      if (refreshToken) { await CommonAxiosPost("killtoken", { refresh_token: refreshToken }); }

    } catch (err) {
      console.warn("Idle logout API failed:", err?.response?.status);
    } finally { localStorage.clear(); window.location.href = config.url.UI_URL; }
  };
  useEffect(() => {

    if (localStorage.getItem('token') === null || localStorage.getItem('token') === undefined) {
      localStorage.clear();
    }

    const handleContextMenu = (e) => {
      e.preventDefault();
      alert("You are not allowed to perform this action!");
    };

    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) || // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) || // Ctrl+Shift+C
        (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) || // Ctrl+Shift+J
        (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) // Ctrl+U
      ) {
        e.preventDefault();
        alert("You are not allowed to perform this action!");
        return false;
      }
    };


    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);


    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>

      <IdleTimerProvider
        timeout={1800000}
        onIdle={handleOnIdle} >
        <div className="main_section"></div>
        <RoutesComponent />
      </IdleTimerProvider>



    </>
  );
}

export default App;